export default "__VITE_ASSET__BbOQf1XQ__"